export const projects = [
  {
    id: 'system-001',
    title: 'System 001',
    category: 'Fashion Manufacturing & Export',
    problemState: [
      'Established clothing brand with 8 years of domestic operation.',
      'Strong local demand but no export infrastructure.',
      'Owner spending 25+ hours weekly on supplier coordination.',
      'No standardized costing or margin tracking.',
      'Production delays averaging 3 weeks per order cycle.',
    ],
    constraintsImposed: [
      'Full control of supplier and manufacturer coordination.',
      'Owner removed from day-to-day production management.',
      'Standardized costing and margin reporting adopted.',
      'Minimum 6-month engagement term.',
    ],
    systemsDeployed: [
      'Supplier management and quality control framework',
      'Production scheduling and capacity planning system',
      'Export compliance and documentation workflow',
      'Cost tracking and margin analysis dashboard',
      'Inventory and order management integration',
    ],
    outcomes: [
      { metric: 'Production lead time', before: '6 weeks', after: '2.5 weeks' },
      { metric: 'Owner operational time', before: '25+ hrs/week', after: '3 hrs/week' },
      { metric: 'Gross margin visibility', before: 'None', after: 'Real-time by SKU' },
      { metric: 'Export markets entered', note: '4 new territories' },
    ],
  },
  {
    id: 'system-002',
    title: 'System 002',
    category: 'Multi-Location Service Business',
    problemState: [
      'Salon group with 5 locations, operating for 12 years.',
      'Revenue of $2.1M annually but no financial structure.',
      'Owner acting as de facto operations manager across all sites.',
      'Staff scheduling done manually via WhatsApp.',
      'No institutional readiness for external investment or franchising.',
    ],
    constraintsImposed: [
      'Complete handover of financial operations.',
      'Owner approval required only for expenditures exceeding defined thresholds.',
      'Standardized reporting and compliance framework adoption.',
    ],
    systemsDeployed: [
      'Centralized financial management and reporting',
      'Staff scheduling and payroll automation',
      'Location performance tracking and benchmarking',
      'Compliance and audit-readiness framework',
      'Franchise documentation and operational playbook',
    ],
    outcomes: [
      { metric: 'Monthly close time', before: '18 days', after: '3 days' },
      { metric: 'Financial visibility', before: 'Quarterly estimate', after: 'Weekly actuals' },
      { metric: 'Staff scheduling time', before: '8 hrs/week', after: '45 min/week' },
      { metric: 'Franchise readiness', note: 'Documentation complete' },
    ],
  },
  {
    id: 'system-003',
    title: 'System 003',
    category: 'Physical Goods Distribution',
    problemState: [
      'Specialty food producer with regional distribution.',
      'Monthly revenue of $180K with strong repeat customer base.',
      'Fulfillment handled by owner and 2 staff manually.',
      'No cold chain tracking or compliance documentation.',
      'Expansion blocked by operational capacity.',
    ],
    constraintsImposed: [
      'Full control of logistics and distribution operations.',
      'Cold chain compliance system implementation mandatory.',
      'Owner removed from daily fulfillment decisions.',
    ],
    systemsDeployed: [
      'Warehouse management and inventory control',
      'Cold chain monitoring and compliance logging',
      'Order routing and carrier optimization',
      'Distributor management and territory tracking',
      'Regulatory documentation and export certification',
    ],
    outcomes: [
      { metric: 'Order processing time', before: '48 hours', after: '4 hours' },
      { metric: 'Fulfillment errors', before: '9%', after: '0.8%' },
      { metric: 'Distribution capacity', change: '+340%' },
      { metric: 'Export certification', note: 'EU and UK compliant' },
    ],
  },
  {
    id: 'system-004',
    title: 'System 004',
    category: 'Professional Services Firm',
    problemState: [
      'Consulting practice with 14 staff, 6 years in operation.',
      'Client onboarding averaging 15 business days.',
      'No standardized delivery process across engagements.',
      'Owner personally managing all client relationships.',
      'Revenue per employee significantly below industry benchmark.',
    ],
    constraintsImposed: [
      'Process documentation and standardization authority.',
      'Client communication protocols established.',
      'Owner transitioned to business development only.',
    ],
    systemsDeployed: [
      'Client onboarding and project initiation workflow',
      'Standardized service delivery framework',
      'Resource allocation and utilization tracking',
      'Client communication and reporting automation',
      'Quality assurance and feedback loop',
    ],
    outcomes: [
      { metric: 'Client onboarding', before: '15 days', after: '4 days' },
      { metric: 'Revenue per employee', change: '+67%' },
      { metric: 'Client satisfaction (NPS)', before: '34', after: '71' },
      { metric: 'Owner client time', before: '30 hrs/week', after: '8 hrs/week' },
    ],
  },
];

export default projects;
